import React from 'react';
import {
  HorizontalRule,
  Heading,
  IconStatusWarningOnlight,
  Paragraph,
  Button,
} from '@piggybank/core';
import { useSelector } from 'react-redux';
import { Translation } from 'srcAlias/client/locale';
import useTrackPageViewAnalytics from 'srcAlias/client/global/customHooks/useTrackPageViewAnalytics';
import { clickContinue } from 'srcAlias/client/utils/clickContinue';
import { isMobileJourney } from 'srcAlias/client/utils/urlParameters';
import { selectQueryParams } from 'srcAlias/client/state/selectors';
import config from 'configAlias';
export const AbsoluteSession = () => {
  useTrackPageViewAnalytics('sessionTimeout');
  const queryParams = useSelector(selectQueryParams);

  return (
    <>
      <span style={{ color: 'var(--gold)' }}>
        <IconStatusWarningOnlight width="3em" />{' '}
      </span>
      <Heading level={1}>
        <Translation path="sessionTimeout.heading" />
      </Heading>
      <HorizontalRule marginBottom={4} />
      <Paragraph marginBottom={6}>
        <Translation path="sessionTimeout.paragraph" />
      </Paragraph>
      {!isMobileJourney(queryParams) && (
        <Button
          onClick={() =>
            clickContinue('sessionTimeoutPage', __GOTOMYACCOUNT_URL__)
          }
          secondary={config.isSecondaryButton}
          elementType="a"
          href={__GOTOMYACCOUNT_URL__}
          target="_self"
        >
          <Translation path="sessionTimeout.goToMyAccount" />
        </Button>
      )}
    </>
  );
};

// default AbsoluteSession;
